import { DirectorAccess } from '@teetsh/app/src/containers/Demarrage/steps/DirectorAccess';
import React from 'react';
import { EcoleStep } from './steps/Ecole';
import { DemarrageWrapper } from '.';
import { Classes } from './steps/Classes';
import { Role } from './steps/Role';
import { Objectifs } from './steps/Objectifs';
import { WorkingDays } from '@teetsh/app/src/containers/Demarrage/steps/WorkingDays';
import { Bienvenue } from '@teetsh/app/src/containers/Demarrage/steps/Bienvenue';
import { EcoleDetails } from '@teetsh/app/src/containers/Demarrage/steps/EcoleDetails';
import { loader as demarrageLoader } from '@teetsh/app/src/containers/Demarrage/queries/useDemarrage';
import { queryClient } from '@teetsh/app/src/queryClient';
import { Preparation } from '@teetsh/app/src/containers/Demarrage/steps/Preparation';
import { Finalized } from '@teetsh/app/src/containers/Demarrage/steps/Finalized';
import { Navigate } from 'react-router-dom';
import { OrganisationMultiNiveaux } from '@teetsh/app/src/containers/Demarrage/steps/OrganisationMultiNiveaux';
import { PageTrackerWrapper } from '@teetsh/app/src/queries/user/track';
import { Pays } from './steps/Pays';

export const DemarrageRoutes = {
  path: 'demarrage',
  element: <DemarrageWrapper />,
  loader: demarrageLoader(queryClient),
  children: [
    {
      path: 'bienvenue',
      element: (
        <PageTrackerWrapper title="Demarrage - Bienvenue">
          <Bienvenue />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'pays',
      element: (
        <PageTrackerWrapper title="Demarrage - Pays">
          <Pays />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'role',
      element: (
        <PageTrackerWrapper title="Demarrage - Role">
          <Role />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'directeur-access',
      element: (
        <PageTrackerWrapper title="Demarrage - Directeur accès">
          <DirectorAccess />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'ecole',
      element: (
        <PageTrackerWrapper title="Demarrage - École">
          <EcoleStep />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'ecole-details',
      element: (
        <PageTrackerWrapper title="Demarrage - École détails">
          <EcoleDetails />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'classes',
      element: (
        <PageTrackerWrapper title="Demarrage - Classes">
          <Classes />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'organisation-multi-niveaux',
      element: (
        <PageTrackerWrapper title="Demarrage - Organisation muli niveaux">
          <OrganisationMultiNiveaux />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'jours-travailles',
      element: (
        <PageTrackerWrapper title="Demarrage - Jours travaillés">
          <WorkingDays />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'objectifs',
      element: (
        <PageTrackerWrapper title="Demarrage - Objectifs">
          <Objectifs />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'preparation',
      element: (
        <PageTrackerWrapper title="Demarrage - Préparation">
          <Preparation />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'final',
      element: (
        <PageTrackerWrapper title="Demarrage - Finalisé">
          <Finalized />
        </PageTrackerWrapper>
      ),
    },
    {
      index: true,
      element: <Navigate to="/demarrage/bienvenue" />,
    },
  ],
};
